/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ActivitiesIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABbklEQVR4nOWUu04CURCGN14be2PU1s7Cws6EFgNz2eI4g/T0FmpisyImYu0LmPgIGnwAjIWtTyAilY+gwRxwcVl3ceGEykmm2TPn+2f+nV3P+9eBqFtIcoOsbSD5RNYukLwWWXbd4SyHITSewNpyggNpNQkcTYfO9WzQKcldoWBWfb+8hqSNn+f64QxH1q4Fh2dEsj6xRUEQzABJLW5DmgCSXCeCjDGzQHJit+Ivj7EH0oYV6cFJ7kN7iPY3k+BLSHqbCcwjEvUg2V/SJ1c4kJym+gysJSR9mAo8GsyyYYuR9WUMgcAbN3K53FzS5vzuXKueS0B/mlQBu8KZQMaYBWS5BJIOkjRjIsfOvwRkrY+6CKTnTgLA8ha9WOTSTnxCIHl3mSDla5WBXUh6FVvNjrsAazusKfp72zGBmrMAkF4M1ZE+f0/2mM/nF7MLkDSHwP13UrfeR+uA9Mie+X55JTN8nKhUKvMAujwV+CTxBerGrhZCuSorAAAAAElFTkSuQmCC)
 */
export const ActivitiesIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M22 4v1.51a6 6 0 0 1-1.76 4.25l-4.1 4.1a.5.5 0 0 0-.14.35v3.74a3 3 0 0 1-.66 1.87l-1.79 2.24a.5.5 0 0 1-.86-.14l-1.86-5.02a.5.5 0 0 0-.11-.18l-3.46-3.46a.5.5 0 0 0-.17-.11l-4.8-1.85a.5.5 0 0 1-.15-.85l2.02-1.73A3 3 0 0 1 6.1 8h3.68a.5.5 0 0 0 .36-.15l4.1-4.1A6 6 0 0 1 18.48 2H20a2 2 0 0 1 2 2Zm-5 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9 19a1 1 0 0 0-1-1H7a1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1 3 3 0 0 0-3 3v3a1 1 0 0 0 1 1h3a3 3 0 0 0 3-3Z"
        className={colorClass}
      />
    </svg>
  );
};
